module.exports = __webpack_public_path__ + "static/media/5_2.b1827327.jpg";